import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import HbsVeznePoscihaztanimDTO from "src/models/Vezne/PosCihazTanim/HbsVeznePoscihaztanimDTO";
import HbsVeznePoscihaztanimDTOService from "src/services/Vezne/PosCihazTanim/HbsVeznePoscihaztanimDTO.service";

export const getByPosId = createAsyncThunk(
    'HbsVeznePoscihaztanimDTOService/getByPosId',
    async (posId: number, thunkAPI) => {
        const response = await HbsVeznePoscihaztanimDTOService.getByPosId(posId);
        return response
    }
);

export const getByAllData = createAsyncThunk(
    'HbsVeznePoscihaztanimDTOService/getByAllData',
    async () => {
        const response = await HbsVeznePoscihaztanimDTOService.getByAllData();
        return response
    }
);

export const deleteRecord = createAsyncThunk(
    'HbsVeznePoscihaztanimDTOService/deleteRecord',
    async (id: number) => {
        const response = await HbsVeznePoscihaztanimDTOService.deleteRecord(id);
        return response;
    }
);

export const createUpdate = createAsyncThunk(
    'HbsVeznePoscihaztanimDTOService/createUpdate',
    async (data: HbsVeznePoscihaztanimDTO, thunkAPI) => {
        const response = await HbsVeznePoscihaztanimDTOService.createUpdate(data);
        return response
    }
);

export const getDetayliArama = createAsyncThunk(
    'HbsVeznePoscihaztanimDTOService/getDetayliArama',
    async (aramaModel: HbsVeznePoscihaztanimDTO, thunkAPI) => {
        const response = await HbsVeznePoscihaztanimDTOService.getDetayliArama(aramaModel);
        return response
    }
);

export interface IPosCihazTanimState extends GridState<HbsVeznePoscihaztanimDTO> {
    dialog?: boolean;
    searchModel?: HbsVeznePoscihaztanimDTO;
}

const PosCihazTanimSlice = createSlice<IPosCihazTanimState, MapReducerPayloads<IPosCihazTanimState, {
    setState: IPosCihazTanimState,
    setDialog: boolean
}>>({
    name: 'PosCihazTanimState',
    initialState: {
        data: [],
        activeRow: new HbsVeznePoscihaztanimDTO(),
        searchModel: new HbsVeznePoscihaztanimDTO(),
        isFetching: true,
        dialog: false,
    },
    reducers: {
        setState: (state, action) => action.payload,
        setDialog: (state, action) => {
            state.dialog = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getByAllData.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(getByAllData.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.data ? action.payload.data : [],
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false
            }
        });
        builder.addCase(deleteRecord.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(deleteRecord.fulfilled, (state, action) => {
            state.data = state.data.filter(f => f?.id !== state?.activeRow?.id).map((m) => m)
            state.errorMessage = action.payload.errorMessage
            state.isLoading = false
            return state;
        });
        builder.addCase(createUpdate.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(createUpdate.fulfilled, (state, action) => {
            return {
                ...state,
                activeRow: action.payload.responseCode !== 200 ? state.activeRow : action.payload.data,
                errorMessage: action.payload.errorMessage,
                isLoading: false
            }
        });
        builder.addCase(getDetayliArama.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(getDetayliArama.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.data ? action.payload.data : [],
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false
            }
        });
    }
})
export default PosCihazTanimSlice;